export enum SeraTableLoaderAction {
    Add = 'ADD',
    Delete = 'DELETE',
    GetLink = 'GETLINK'
}
